<template>
    <div class="mx-auto p-4 lg:max-w-7xl">
        <div class="grid gap-8 md:grid-cols-2 lg:grid-cols-3" ref="offersContainerRef">
            <IframeOfferCard v-for="offer in offers.data" :key="offer.title" :offer="offer" />
        </div>

        <div class="flex items-center justify-center py-24">
            <a href="https://camaq.ca/emplois" target="_blank" class="button flex items-center gap-4">
                Voir tous les postes sur CAMAQ
                <IconExternalLink class="size-5" />
            </a>
        </div>
    </div>
</template>

<script setup>
    import IframeOfferCard from '@/Partials/IframeOfferCard.vue';
    import { IconExternalLink } from '@tabler/icons-vue';

    const props = defineProps({
        offers: Object,
    });
</script>
